import React from 'react';
import { Logo } from './WelcomeStyles';
import logo from '../../images/hub_logo.png';

const WelcomeLogo = () => {
  return (
    <Logo src={logo} alt="logo"/>
  )
}

export default WelcomeLogo